/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataSegment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M9 2a1 1 0 0 0-.707.293l-6 6A1 1 0 0 0 2 9v12a1 1 0 0 0 1 1h12a1 1 0 0 0 .707-.293l6-6A1 1 0 0 0 22 15V3a1 1 0 0 0-1-1zM5.414 8l4-4h9.172l-4 4zM16 9.414l4-4v9.172l-4 4zM14 10v10H4V10zm-2 2H6v6h6z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDataSegment as DataSegment };
